import { render, staticRenderFns } from "./teacherclasse.vue?vue&type=template&id=3b543457&"
import script from "./teacherclasse.vue?vue&type=script&lang=js&"
export * from "./teacherclasse.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports